import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.227 17.91h-5.861l6.408-6.41a.773.773 0 000-1.092l-6.182-6.182a.773.773 0 00-1.093 0L4.226 13.5a.772.772 0 000 1.093l4.637 4.636a.773.773 0 00.546.226H20.227a.773.773 0 100-1.545zM14.045 5.865l5.09 5.089-4.471 4.47-5.09-5.089 4.471-4.47z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
